<template>
    <div v-if="model.general_setting">
        <h4 class="group__headline">Automatic cancellation</h4>
        <el-form-item label="Automatic cancellation">
            <el-radio
                v-model="model.general_setting.auto_cancel_orders"
                label="1"
                >Yes</el-radio
            >
            <el-radio
                v-model="model.general_setting.auto_cancel_orders"
                label="0"
                >No</el-radio
            >
        </el-form-item>
        <el-form-item label="Days until automatic cancellation">
            <el-input
                v-model="model.general_setting.auto_cancel_orders_in_days"
            ></el-input>
        </el-form-item>
        <el-form-item label="Automatically fill up stock">
            <el-radio
                v-model="model.general_setting.auto_stock_refill"
                label="1"
                >Yes</el-radio
            >
            <el-radio
                v-model="model.general_setting.auto_stock_refill"
                label="0"
                >No</el-radio
            >
        </el-form-item>
        <h4 class="group__headline mt-20">Abandonded cart</h4>
        <el-form-item label="Send reminder">
            <el-radio v-model="model.general_setting.auto_abandonded" label="1"
                >Yes</el-radio
            >
            <el-radio v-model="model.general_setting.auto_abandonded" label="0"
                >No</el-radio
            >
        </el-form-item>
        <el-form-item label="In how many minutes?">
            <el-input
                v-model="model.general_setting.auto_abandonded_in_minutes"
            ></el-input>
        </el-form-item>
        <el-form-item label="BCC email">
            <el-input
                v-model="model.general_setting.auto_abandoned_bcc"
            ></el-input>
            <template v-for="(data, index) in modelOrigin">
                <div
                    v-if="
                        data.setting_key === 'auto_abandoned_bcc' &&
                        origins.length &&
                        isValidOrigin(data.origin_id)
                    "
                    class="mt-4 p-4 border rounded border-gray-500 border-solid w-1/2 ml-auto"
                >
                    <div class="flex">
                        <div class="grow-0 shrink-0 basis-32">
                            Setting for {{ getOriginName(data.origin_id) }}
                        </div>
                        <el-input
                            v-model="modelOrigin[index].setting"
                        ></el-input>
                    </div>
                    <div class="flex justify-end mt-4">
                        <el-button
                            type="primary"
                            @click="
                                onSubmitOriginSetting(
                                    data.id,
                                    modelOrigin[index].setting
                                )
                            "
                            >Save setting for
                            {{ getOriginName(data.origin_id) }}</el-button
                        >
                    </div>
                </div>
            </template>
        </el-form-item>
        <h4 class="group__headline mt-20">Outstanding payments</h4>
        <el-form-item label="Send reminder">
            <el-radio v-model="model.general_setting.unpaid_orders_alert_enabled" label="1"
                >Yes</el-radio
            >
            <el-radio v-model="model.general_setting.unpaid_orders_alert_enabled" label="0"
                >No</el-radio
            >
        </el-form-item>
        <el-form-item label="In how many days?">
            <el-input
                v-model="model.general_setting.auto_reminder_in_days"
            ></el-input>
        </el-form-item>
        <h4 class="group__headline mt-20">Automatically mark as delivered</h4>
        <el-form-item label="Automatically mark as delivered">
            <el-radio
                v-model="model.general_setting.auto_update_delivered"
                label="1"
                >Yes</el-radio
            >
            <el-radio
                v-model="model.general_setting.auto_update_delivered"
                label="0"
                >No</el-radio
            >
        </el-form-item>
    </div>
</template>

<script>
export default {
    props: ['model', 'modelOrigin', 'settings', 'rootConfig', 'api'],

    data() {
        return {
            origins: [],
            loading: true,
        };
    },

    created() {
        this.$resource(
            this.rootConfig.endPoint + '/origins',
            {},
            {},
            { headers: this.rootConfig.headers }
        )
            .get()
            .then((res) => {
                this.loading = false;
                this.origins = res.data;
            });
    },

    methods: {
        isValidOrigin(origin_id) {
            return this.origins.find((origin) => origin.id === origin_id);
        },
        getOriginName(origin_id) {
            return this.origins.find((origin) => origin.id === origin_id).name;
        },
        onSubmitOriginSetting(id, setting) {
            const data = { id, setting };
            this.$resource(
                this.rootConfig.endPoint + '/settings/{id}',
                {},
                {},
                { headers: this.rootConfig.headers }
            )
                .update({ id }, data)
                .then(() => {
                    this.$message('Updated successfully');
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// Automation.vue?dac20202